import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Global Selectors
// @ts-ignore
import {
    selectSpraySchemaExists,
    selectHarvestSchemaExists
} from 'services/schemas/selectors';

export interface OwnProps {
    children: React.ReactElement;
}

interface ConnectedProps {
    spraySchemaExists?: boolean;
    harvestSchemaExists?: boolean;
}

type Props = OwnProps & ConnectedProps;

/**
 * A component to wrap around content only visible to organisations that have a the settings feature enabled.
 */
export class SettingsExistsGate extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { children, spraySchemaExists, harvestSchemaExists } = this.props;

        if (!spraySchemaExists && !harvestSchemaExists) {
            return null;
        }
        return children;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    spraySchemaExists: selectSpraySchemaExists,
    harvestSchemaExists: selectHarvestSchemaExists
});

export default connect(mapStateToProps)(SettingsExistsGate);
